const modalContent = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
};

export default {
  loading: {
    ...modalContent,
    padding: 20
  },
  queryResult: {
    padding: '15px 50px 0px',
    textAlign: 'justify',
    display: 'flex',
    flexDirection: 'column'
  },
  clientNumber: {
    paddingBottom: 10
  }
};
